import { render } from "./VertragsKonto.pug?vue&type=template&id=e4d6999e&lang=pug"
import script from "./VertragsKonto.js?vue&type=script&lang=js"
export * from "./VertragsKonto.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__